// extracted by mini-css-extract-plugin
export var documentation = "_k0-1";
export var menu = "_k0-0";